import React from 'react';
import { Link } from 'react-router-dom';
import { PlayerMatchStats, Team, SideFilter } from '../../types/match.types';

interface TeamStatsSectionProps {
  team: Team;
  players: PlayerMatchStats[];
  isWinner: boolean;
  score: number;
  selectedSide: SideFilter;
  teamLogoUrl?: string;
}

const TeamStatsSection: React.FC<TeamStatsSectionProps> = ({
  team,
  players,
  isWinner,
  score,
  selectedSide,
  teamLogoUrl
}) => {
  // Sort players by rating
  const sortedPlayers = [...players].sort((a, b) => b.rating2 - a.rating2);

  return (
    <div className="team-section">
      <div className="players-stats">
        <div className={`stats-header ${
          selectedSide === "t"
            ? "t-side-active"
            : selectedSide === "ct"
            ? "ct-side-active"
            : ""
        }`}>
          <div className="player-name-col team-info-header">
            <img
              src={teamLogoUrl || team.teamLogo}
              alt={team.teamName}
              className="team-logo-inline"
            />
            <div className="team-text-group">
              <span className="team-name-inline">{team.teamName}</span>
              <span className={`team-score-inline ${isWinner ? "winner-score" : "loser-score"}`}>{score}</span>
            </div>
          </div>
          <div className="stat-col">K</div>
          <div className="stat-col">D</div>
          <div className="stat-col">A</div>
          <div className="stat-col">K/D</div>
          <div className="stat-col">ADR</div>
          <div className="stat-col">HS%</div>
          <div className="stat-col">KAST</div>
          <div className="stat-col">Rating</div>
        </div>

        {sortedPlayers.map((player) => (
          <div key={player.steamId} className="player-stats-row">
            <Link
              to={`/profile/${player.steamId}`}
              className="player-name-col"
            >
              <span className="player-name">
                {player.account.playerName}
              </span>
              <span className="real-name">{player.account.name}</span>
            </Link>
            <div className="stat-col">{player.kills}</div>
            <div className="stat-col">{player.deaths}</div>
            <div className="stat-col">{player.assists}</div>
            <div className="stat-col">{player.kd.toFixed(2)}</div>
            <div className="stat-col">{player.adr.toFixed(1)}</div>
            <div className="stat-col">{player.hs.toFixed(0)}%</div>
            <div className="stat-col">{player.kast.toFixed(1)}%</div>
            <div className="stat-col rating">
              {player.rating2.toFixed(2)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamStatsSection;